import { call, put, takeLatest, select } from 'typed-redux-saga'
import { errorHandler, gridSlice, notifyMessageCreator } from 'Modules'
import { cloneDeep } from 'lodash'
import { tagApi, TagModel, tagNS, tagSelector, tagSlice } from 'Pages/admin'
import { ResponseCatalog, RequestParams } from 'Models'

function* getAll(action: tagNS.getAllTag) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(tagSlice.actions.clearAll())
		}
		const res = yield* call(tagApi.getAll, requestParams)
		const tags = new ResponseCatalog<TagModel>(res)
		if (!clear) {
			const oldTags = yield* select(tagSelector.getEntries)
			tags.entries = oldTags.concat(res.entries)
		}
		yield* put(tagSlice.actions.setAll(tags))
		yield* put(tagSlice.actions.setParams(requestParams))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}
function* createOne(action: tagNS.createTag) {
	try {
		const { tag, callback } = action.payload
		const res = yield* call(tagApi.createOne, tag)
		yield* put(
			tagSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
			})
		)
		callback?.()
		yield* call(notifyMessageCreator, 'knowledge.tag_create.success', { data: [res.name] })
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateOne(action: tagNS.updateTag) {
	try {
		const { tag, id } = action.payload
		const res = yield* call(tagApi.updateOne, tag, id)
		yield* put(
			tagSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
			})
		)
		yield* call(notifyMessageCreator, 'knowledge.tag_update.success', { data: [res.name] })
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* deleteOne(action: tagNS.deleteTag) {
	try {
		const { id } = action.payload
		yield* call(tagApi.deleteOne, id)
		yield* put(
			tagSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
			})
		)
		yield* call(notifyMessageCreator, 'knowledge.tag_delete.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getRandomTag(action: tagNS.getRandomTag) {
	try {
		const res = yield* call(tagApi.getAllRandom)
		const tags = cloneDeep(res.entries)
		// @ts-ignore TODO: fix types
		yield* put(tagSlice.actions.setAllRandomTag(tags))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* tagSaga() {
	yield* takeLatest(tagSlice.actions.getAll.type, getAll)
	yield* takeLatest(tagSlice.actions.createOne.type, createOne)
	yield* takeLatest(tagSlice.actions.updateOne.type, updateOne)
	yield* takeLatest(tagSlice.actions.deleteOne.type, deleteOne)
	yield* takeLatest(tagSlice.actions.getRandomTag.type, getRandomTag)
}
